export default __webpack_public_path__ + "static/media/mint_background.aea29d1b.svg";